import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Booking from "./pages/Booking";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PhotoUpdates from "./pages/PhotoUpdates";
import Facility from "./pages/Facility";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

// Layout wrapper to conditionally show header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdminRoute && <Header />}
      <main>{children}</main>
      {!isAdminRoute && <Footer />}
    </>
  );
};

function App() {
  // Suppress ResizeObserver errors globally (these are harmless dev warnings)
  useEffect(() => {
    // Error event handler
    const handleError = (e) => {
      if (e.message && (
        e.message.includes('ResizeObserver loop') || 
        e.message.includes('ResizeObserver loop completed with undelivered notifications') ||
        e.message.includes('ResizeObserver loop limit exceeded')
      )) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
      }
    };

    // Unhandled rejection handler
    const handleRejection = (e) => {
      if (e.reason && e.reason.message && (
        e.reason.message.includes('ResizeObserver loop') ||
        e.reason.message.includes('ResizeObserver loop completed with undelivered notifications')
      )) {
        e.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    // Also suppress webpack dev overlay for ResizeObserver
    const originalError = console.error;
    console.error = (...args) => {
      if (
        typeof args[0] === 'string' &&
        (args[0].includes('ResizeObserver loop') ||
         args[0].includes('ResizeObserver loop completed with undelivered notifications'))
      ) {
        return;
      }
      originalError.apply(console, args);
    };

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
      console.error = originalError;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/facility" element={<Facility />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/furry-friends" element={<PhotoUpdates />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
